<template>
  <div class="attendance-table-container">
    <el-table
        :data="items"
        v-loading="loading"
        border
        class="sk-table custom-attendance-table"
        style="width: 100%"
        :max-height="$tableMaxHeight"
    >
      <el-table-column
          type="selection"
          width="50"
          align="center"
          fixed="left"
      />

      <el-table-column type="index" label="STT" width="55" align="center" fixed="left"/>

      <el-table-column label="Học sinh" prop="nameStudent" min-width="180" fixed="left">
        <template #default="{ row }">
          <div class="student-profile-cell">
            <span class="student-name-text">{{ row.nameStudent }}</span>
          </div>
        </template>
      </el-table-column>

      <!-- Khối nhóm cột: Điểm danh -->
      <el-table-column label="Thông tin điểm danh" align="center">
        <el-table-column label="Đi học" width="105" align="center">
          <template #header="">
            <span class="second-title title-present">Đi học</span>
            <div class="header-checkbox-wrapper">
              <el-checkbox
                  :indeterminate="isIndeterminate('PRESENT')"
                  :value="isCheckAll('PRESENT')"
                  @change="val => onCheckAllChange(val, 'PRESENT')"
              ></el-checkbox>
            </div>
          </template>
          <template #default="{ row }">
            <div class="status-cell">
              <el-checkbox :value="isCheckedStatus(row, 'PRESENT')"
                           @change="val => onStatusCheckboxEl(val, row, 'PRESENT')"/>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Có phép" width="105" align="center">
          <template #header="">
            <span class="second-title title-absent-cp">Có phép</span>
            <div class="header-checkbox-wrapper">
              <el-checkbox
                  :indeterminate="isIndeterminate('ABSENT_CP')"
                  :value="isCheckAll('ABSENT_CP')"
                  @change="val => onCheckAllChange(val, 'ABSENT_CP')"
              ></el-checkbox>
            </div>
          </template>
          <template #default="{ row }">
            <div class="status-cell">
              <el-checkbox :value="isCheckedStatus(row, 'ABSENT_CP')"
                           @change="val => onStatusCheckboxEl(val, row, 'ABSENT_CP')"/>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Không phép" width="105" align="center">
          <template #header="">
            <span class="second-title title-absent-kp">Không phép</span>
            <div class="header-checkbox-wrapper">
              <el-checkbox
                  :indeterminate="isIndeterminate('ABSENT_KP')"
                  :value="isCheckAll('ABSENT_KP')"
                  @change="val => onCheckAllChange(val, 'ABSENT_KP')"
              ></el-checkbox>
            </div>
          </template>
          <template #default="{ row }">
            <div class="status-cell">
              <el-checkbox :value="isCheckedStatus(row, 'ABSENT_KP')"
                           @change="val => onStatusCheckboxEl(val, row, 'ABSENT_KP')"/>
            </div>
          </template>
        </el-table-column>

        <!-- Khối thời gian -->
        <el-table-column label="Giờ đến" width="115" align="center">
          <template #default="{ row }">
            <el-time-picker
                v-if="currentStatus(row) === 'PRESENT'"
                :value="getTime(row, 'arriveTime')"
                @input="val => onTimeChange(val, row, 'arriveTime')"
                value-format="HH:mm"
                format="HH:mm"
                class="custom-time-picker"
                size="mini"
                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                placeholder="--:--"
            />
            <span v-else class="text-disabled">-</span>
          </template>
        </el-table-column>

        <el-table-column label="Giờ về" width="115" align="center">
          <template #header="">
            <span class="second-title">Giờ về</span>
            <div class="header-checkbox-wrapper">
              <el-checkbox
                  :indeterminate="isLeaveTimeIndeterminate()"
                  :value="isLeaveTimeCheckAll()"
                  @change="onCheckAllLeaveTime"
              ></el-checkbox>
            </div>
          </template>
          <template #default="{ row }">
            <el-time-picker
                v-if="currentStatus(row) === 'PRESENT'"
                :value="getTime(row, 'leaveTime')"
                @input="val => onTimeChange(val, row, 'leaveTime')"
                value-format="HH:mm"
                format="HH:mm"
                class="custom-time-picker"
                size="mini"
                :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                placeholder="--:--"
            />
            <span v-else class="text-disabled">-</span>
          </template>
        </el-table-column>

        <el-table-column label="Đi muộn" width="95" align="center">
          <template #default="{ row }">
            <span v-if="row.arrivingLate" class="badge-minute badge-minute--late">{{ row.arrivingLate }} ph</span>
            <span v-else class="text-disabled">-</span>
          </template>
        </el-table-column>

        <el-table-column label="Đón muộn" width="95" align="center">
          <template #default="{ row }">
            <span v-if="row.latePickup" class="badge-minute badge-minute--pickup">{{ row.latePickup }} ph</span>
            <span v-else class="text-disabled">-</span>
          </template>
        </el-table-column>
      </el-table-column>

      <!-- Khối nhóm cột: Chế độ Ăn uống -->
      <el-table-column label="Ăn" align="center">
        <el-table-column label="Sáng" width="85" align="center">
          <template #header="">
            <span class="second-title">Sáng</span>
            <div class="header-checkbox-wrapper">
              <el-checkbox
                  :indeterminate="isMealIndeterminate('breakfast')"
                  :value="isMealCheckAll('breakfast')"
                  @change="val => onCheckAllMealChange(val, 'breakfast')"
              />
            </div>
          </template>
          <template #default="{ row }">
            <div class="status-cell">
              <el-checkbox
                  v-if="currentStatus(row) === 'PRESENT'"
                  :value="getAttendanceEat(row, 'breakfast')"
                  @change="val => onCheckAttendanceEat(val, row, 'breakfast')"
              />
              <span v-else class="text-disabled">-</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Chính" width="85" align="center">
          <template #header="">
            <span class="second-title">Chính</span>
            <div class="header-checkbox-wrapper">
              <el-checkbox
                  :indeterminate="isMealIndeterminate('mainMeal')"
                  :value="isMealCheckAll('mainMeal')"
                  @change="val => onCheckAllMealChange(val, 'mainMeal')"
              />
            </div>
          </template>
          <template #default="{ row }">
            <div class="status-cell">
              <el-checkbox
                  v-if="currentStatus(row) === 'PRESENT'"
                  :value="getAttendanceEat(row, 'mainMeal')"
                  @change="val => onCheckAttendanceEat(val, row, 'mainMeal')"/>
              <span v-else class="text-disabled">-</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Phụ" width="85" align="center">
          <template #header="">
            <span class="second-title">Phụ</span>
            <div class="header-checkbox-wrapper">
              <el-checkbox
                  :indeterminate="isMealIndeterminate('snack')"
                  :value="isMealCheckAll('snack')"
                  @change="val => onCheckAllMealChange(val, 'snack')"
              />
            </div>
          </template>
          <template #default="{ row }">
            <div class="status-cell">
              <el-checkbox
                  v-if="currentStatus(row) === 'PRESENT'"
                  :value="getAttendanceEat(row, 'snack')"
                  @change="val => onCheckAttendanceEat(val, row, 'snack')"
              />
              <span v-else class="text-disabled">-</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Tối" width="85" align="center">
          <template #header="">
            <span class="second-title">Tối</span>
            <div class="header-checkbox-wrapper">
              <el-checkbox
                  :indeterminate="isMealIndeterminate('dinner')"
                  :value="isMealCheckAll('dinner')"
                  @change="val => onCheckAllMealChange(val, 'dinner')"
              />
            </div>
          </template>
          <template #default="{ row }">
            <div class="status-cell">
              <el-checkbox
                  v-if="currentStatus(row) === 'PRESENT'"
                  :value="getAttendanceEat(row, 'dinner')"
                  @change="val => onCheckAttendanceEat(val, row, 'dinner')"
              />
              <span v-else class="text-disabled">-</span>
            </div>
          </template>
        </el-table-column>
      </el-table-column>

      <!-- Cột tác vụ hành động -->
      <el-table-column label="Tác vụ" align="center" width="260" fixed="right">
        <template #default="{ row }">
          <div class="action-buttons-wrapper">
            <el-button
                size="mini"
                type="primary"
                :disabled="isButtonDisabled(row)"
                :loading="saving"
                @click.stop="saveAttendance(row)"
                class="row-action-btn btn-save"
            >Lưu</el-button>
            <el-button
                size="mini"
                type="success"
                :disabled="isButtonEditDisabled(row)"
                @click.stop="handleUpdate(row)"
                class="row-action-btn btn-edit"
            >Sửa</el-button>
            <el-button
                size="mini"
                type="primary"
                @click.stop="checkAI(row)"
                class="row-action-btn btn-ai"
            >Kiểm tra AI</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CheckInformationAIDialog
        :dialogVisible="isOpenCheckInformationAIDialog"
        @dialog-close="closeCheckInformationAIDialog()"
        ref="CheckInformationAIDialog"
    />
  </div>
</template>

<script>
import CheckInformationAIDialog from "@/views/attendance-v2/dialog/CheckInformationAIDialog.vue";

export default {
  name: 'AttendanceTable',
  components: { CheckInformationAIDialog },
  props: {
    items: { type: Array, default: () => [] },
    attendanceMap: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    date: { type: Date, default: Date.now },
  },

  data() {
    return {
      isOpenCheckInformationAIDialog: false,
    }
  },

  methods: {
    currentStatus(row) {
      return this.attendanceMap?.[row.idStudent]?.editing?.attendanceStatus
          ?? row.attendanceStatus
          ?? ''
    },

    normalizeTimeToMinute(value) {
      if (!value || typeof value !== 'string') return value || ''
      const timePart = value.includes('T') ? value.split('T')[1] : value
      const parts = timePart.split(':')
      return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : value
    },

    getTime(row, field) {
      const state = (this.attendanceMap && this.attendanceMap[row.idStudent]) || null
      const editing = state && state.editing ? state.editing : null
      // Nếu đang có editing state và field đã được set (kể cả null) thì dùng giá trị editing
      if (editing && Object.prototype.hasOwnProperty.call(editing, field)) {
        return this.normalizeTimeToMinute(editing[field])
      }
      return this.normalizeTimeToMinute(row[field])
    },

    getAttendanceEat(row, field) {
      const state = this.attendanceMap?.[row.idStudent];
      if (state && state.editing && state.editing[field] !== undefined) {
        return !!state.editing[field];
      }
      return !!row[field];
    },

    handleUpdate(row) {
      this.$emit('update', { idStudent: row.idStudent })
    },

    saveAttendance(row) {
      if (this.isButtonDisabled(row)) return
      this.$emit('save-attendance', { rows: [row] })
    },

    checkAI(row) {
      let id = row.idStudent
      let name = row.nameStudent
      const date = new Date(this.date);

      const dateISO = date.toISOString().split('T')[0];

      this.isOpenCheckInformationAIDialog = true;
      this.$refs.CheckInformationAIDialog.getAddDataInitial(id, dateISO, name)
    },

    isCheckedStatus(row, status) {
      return this.currentStatus(row) === status
    },

    getCurrentTimeStr() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    },

    onStatusCheckboxEl(val, row, status) {
      const checked = !!val
      const newStatus = checked ? status : ''

      const state = (this.attendanceMap && this.attendanceMap[row.idStudent]) || null
      const original = state && state.original ? state.original : row
      const editing = state && state.editing ? Object.assign({}, state.editing) : Object.assign({}, original)

      editing.attendanceStatus = newStatus
      editing.attendanceDate = editing.attendanceDate || row.attendanceDate || null

      if (newStatus === 'PRESENT') {
        if (!editing.arriveTime) {
          editing.arriveTime = this.getCurrentTimeStr();
        }
      } else {
        editing.arriveTime = null;
        editing.leaveTime = null;
        editing.breakfast = false;
        editing.mainMeal = false;
        editing.snack = false;
        editing.dinner = false;
      }

      const dirty = this.checkRowDirty(editing, original);
      this.$emit('row-update', { idStudent: row.idStudent, editing, dirty })
    },

    onTimeChange(val, row, field) {
      const state = (this.attendanceMap && this.attendanceMap[row.idStudent]) || null
      const original = state && state.original ? state.original : row
      const editing = state && state.editing ? Object.assign({}, state.editing) : Object.assign({}, original)

      const selectedMinute = this.normalizeTimeToMinute(val);
      const originalMinute = this.normalizeTimeToMinute(original[field]);

      // FE chỉ cho sửa đến phút. Nếu chọn lại đúng phút cũ thì giữ nguyên giây từ API;
      // nếu đổi phút thì lưu ở độ chính xác giây với giây mặc định bằng 00.
      if (selectedMinute && selectedMinute === originalMinute && original[field]) {
        editing[field] = original[field];
      } else {
        editing[field] = selectedMinute ? `${selectedMinute}:00` : null;
      }

      const dirty = this.checkRowDirty(editing, original);
      this.$emit('row-update', { idStudent: row.idStudent, editing, dirty })
    },

    closeCheckInformationAIDialog() {
      this.isOpenCheckInformationAIDialog = false;
    },

    isCheckAll(status) {
      if (!this.items.length) return false;
      return this.items.every(row => this.currentStatus(row) === status);
    },

    isIndeterminate(status) {
      if (!this.items.length) return false;
      const hasStatus = this.items.some(row => this.currentStatus(row) === status);
      const isAll = this.isCheckAll(status);
      return hasStatus && !isAll;
    },

    onCheckAllChange(val, status) {
      const checked = !!val;
      const targetStatus = checked ? status : '';
      this.items.forEach(row => {
        this.onStatusCheckboxEl(checked, row, targetStatus);
      });
    },

    onCheckAttendanceEat(val, row, field) {
      const state = (this.attendanceMap && this.attendanceMap[row.idStudent]) || null
      const original = state && state.original ? state.original : row
      const editing = state && state.editing ? Object.assign({}, state.editing) : Object.assign({}, original)

      editing[field] = !!val;
      const dirty = this.checkRowDirty(editing, original);
      this.$emit('row-update', { idStudent: row.idStudent, editing, dirty })
    },

    checkRowDirty(editing, original) {
      if (!editing || !original) return false;
      const isStatusDirty = (editing.attendanceStatus || '') !== (original.attendanceStatus || '');
      const isArriveTimeDirty = this.normalizeTimeToMinute(editing.arriveTime) !== this.normalizeTimeToMinute(original.arriveTime);
      const isLeaveTimeDirty = this.normalizeTimeToMinute(editing.leaveTime) !== this.normalizeTimeToMinute(original.leaveTime);
      const isBreakfastDirty = !!editing.breakfast !== !!original.breakfast;
      const isMainMealDirty = !!editing.mainMeal !== !!original.mainMeal;
      const isSnackDirty = !!editing.snack !== !!original.snack;
      const isDinnerDirty = !!editing.dinner !== !!original.dinner;

      return isStatusDirty || isArriveTimeDirty || isLeaveTimeDirty || isBreakfastDirty || isMainMealDirty || isSnackDirty || isDinnerDirty;
    },

    isButtonDisabled(row) {
      if (this.saving || this.loading) return true;
      const state = this.attendanceMap?.[row.idStudent];
      if (!state || !state.editing || !state.original) return true;
      return !this.checkRowDirty(state.editing, state.original);
    },

    isButtonEditDisabled(row) {
      const state = this.attendanceMap?.[row.idStudent];
      if (!state || !state.editing || !state.original) return true;

      return state.editing.attendanceStatus == null;
    },

    isMealCheckAll(field) {
      const presentStudents = this.items.filter(row => this.currentStatus(row) === 'PRESENT');
      if (!presentStudents.length) return false;
      return presentStudents.every(row => this.getAttendanceEat(row, field));
    },

    isMealIndeterminate(field) {
      const presentStudents = this.items.filter(row => this.currentStatus(row) === 'PRESENT');
      if (!presentStudents.length) return false;
      const hasMeal = presentStudents.some(row => this.getAttendanceEat(row, field));
      const isAll = this.isMealCheckAll(field);
      return hasMeal && !isAll;
    },

    onCheckAllMealChange(val, field) {
      const checked = !!val;
      this.items.forEach(row => {
        if (this.currentStatus(row) === 'PRESENT') {
          const state = (this.attendanceMap && this.attendanceMap[row.idStudent]) || null;
          const original = state && state.original ? state.original : row;
          const editing = state && state.editing ? Object.assign({}, state.editing) : Object.assign({}, original);
          editing[field] = checked;
          const dirty = this.checkRowDirty(editing, original);
          this.$emit('row-update', { idStudent: row.idStudent, editing, dirty });
        }
      });
    },

    // ─── CHECK ALL GIỜ VỀ ───────────────────────────────────────────
    isLeaveTimeCheckAll() {
      const presentStudents = this.items.filter(row => this.currentStatus(row) === 'PRESENT');
      if (!presentStudents.length) return false;
      return presentStudents.every(row => !!this.getTime(row, 'leaveTime'));
    },

    isLeaveTimeIndeterminate() {
      const presentStudents = this.items.filter(row => this.currentStatus(row) === 'PRESENT');
      if (!presentStudents.length) return false;
      const hasTime = presentStudents.some(row => !!this.getTime(row, 'leaveTime'));
      return hasTime && !this.isLeaveTimeCheckAll();
    },

    onCheckAllLeaveTime(val) {
      const checked = !!val;
      const currentTime = checked ? this.getCurrentTimeStr() : null;
      this.items.forEach(row => {
        if (this.currentStatus(row) === 'PRESENT') {
          const state = (this.attendanceMap && this.attendanceMap[row.idStudent]) || null;
          const original = state && state.original ? state.original : row;
          const editing = state && state.editing ? Object.assign({}, state.editing) : Object.assign({}, original);
          editing.leaveTime = currentTime;
          const dirty = this.checkRowDirty(editing, original);
          this.$emit('row-update', { idStudent: row.idStudent, editing, dirty });
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-table.scss";

.attendance-table-container {
  background-color: #ffffff;
}

// ─── THIẾT KẾ BẢNG ĐIỂM DANH HIỆN ĐẠI (MÀU XANH DƯƠNG GỐC) ───────────
.custom-attendance-table {
  border-radius: 10px !important;
  overflow: hidden;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 16px rgba(51, 65, 85, 0.04);

  // Style Header tầng 1
  /deep/ th.el-table__cell {
    background-color: #6a96d6 !important;
    color: #ffffff !important;
    font-weight: 600;
    padding: 8px 0;
    border-right: 1px solid #e2e8f0 !important;
    font-size: 13px;

    // Style Header tầng con
    &.is-leaf {
      background-color: #6a96d6 !important;
      border-bottom: 1px solid #5a85c2 !important;
      font-size: 12px;
      padding: 6px 0;
    }
  }

  // Hiệu ứng Hover dòng sáng nhẹ xanh dương nhẹ nhàng
  /deep/ tr.el-table__row {
    &:hover > td.el-table__cell {
      background-color: #f0f7ff !important;
    }
  }

  /deep/ td.el-table__cell {
    padding: 8px 0;
    border-bottom: 1px solid #f1f5f9;
    border-right: 1px solid #f1f5f9;
    background-color: #fff;
  }
}

// ─── ĐỊNH DẠNG TEXT TRÊN HEADER ─────────────────────────────────────
.second-title {
  display: inline-block;
  font-weight: 700;
  margin-bottom: 4px;
  font-size: 12px;
  letter-spacing: 0.02em;
  color: #ffffff;
}

.header-checkbox-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
}

// ─── COMPONENT Ô DỮ LIỆU CELLS ──────────────────────────────────────
.student-profile-cell {
  padding-left: 8px;
  display: flex;
  align-items: center;
}

.student-name-text {
  color: #1e293b;
  font-size: 14px;
}

.status-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-disabled {
  color: #cbd5e1;
  font-weight: bold;
}

// Thiết kế TimePicker cân đối ô lưới
.custom-time-picker {
  width: 92% !important;

  /deep/ .el-input__inner {
    padding-left: 24px !important;
    padding-right: 4px !important;
    border-radius: 6px;
    border-color: #cbd5e1;
    font-family: monospace;
    font-size: 12px;
    height: 28px !important;
    line-height: 28px !important;

    &:focus {
      border-color: #78a5e7 !important;
    }
  }
  /deep/ .el-input__icon {
    line-height: 28px !important;
  }
}

// Badge hiển thị số phút đi muộn / về muộn
.badge-minute {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;

  &--late {
    background-color: #fff7ed;
    color: #ea580c;
    border: 1px solid #ffedd5;
  }

  &--pickup {
    background-color: #fdf2f8;
    color: #db2777;
    border: 1px solid #fce7f3;
  }
}

// ─── ĐỒNG BỘ NÚT ĐIỀU KHIỂN HÀNG HOÀN THIỆN ─────────────────────────
.action-buttons-wrapper {
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
  padding: 0 4px;
}

.row-action-btn {
  padding: 6px 10px !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  border-radius: 6px !important;
  transition: all 0.15s ease;
  margin: 0 !important;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.btn-save {
    background-color: #409eff !important;
    border-color: #409eff !important;
    color: #ffffff !important;

    &:hover:not(.is-disabled) {
      background-color: #1d82e6 !important;
      border-color: #1d82e6 !important;
    }

    &.is-disabled {
      background-color: #f3f4f6 !important;
      border-color: #e5e7eb !important;
      color: #9ca3af !important;
    }
  }

  &.btn-edit {
    background-color: #67C23A !important;
    border-color: #67C23A !important;
    color: #ffffff !important;

    &:hover {
      background-color: #529b2e !important;
      border-color: #529b2e !important;
    }

    &.is-disabled {
      background-color: #f3f4f6 !important;
      border-color: #e5e7eb !important;
      color: #9ca3af !important;
    }
  }

  &.btn-ai {
    background-color: #ffffff !important;
    border: 1px solid #dcdfe6 !important;
    color: #409eff !important;

    &:hover {
      background-color: #ecf5ff !important;
      border-color: #409eff !important;
    }
  }
}

// ─── ĐÈ LẠI MÀU HOẠT ĐỘNG CỦA EL-CHECKBOX SANG XANH DƯƠNG ───────────
/deep/ .el-checkbox__inner {
  border-radius: 4px;
  border-color: #7a8a9c;
  width: 16px;
  height: 16px;

  &::after {
    left: 5px;
    top: 2px;
  }
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #78a5e7 !important;
  border-color: #78a5e7 !important;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #78a5e7 !important;
}
</style>
